import styled, { css } from 'styled-components';
import { MIGRATED_COLORS } from 'constants/quartz/migrated_colors';

const SearchInputButtonCss = css`
    background: transparent;
    border: none;
    color: ${MIGRATED_COLORS.literalC4ccd3};
    line-height: 1;
    margin: ${({ margin }) => margin || 0};
    outline: 0;
    padding: 8px 10px;
    position: relative;
    text-decoration: none;
    &:hover {
        color: ${MIGRATED_COLORS.literal98a6b2};
        cursor: pointer;
    }
    &:focus {
        border: none;
        box-shadow: none;
        outline: none;
    }
    /**
     * Add styles for disabled and read-only
     */
    &[disabled],
    &[readonly] {
        background-color: ${MIGRATED_COLORS.literalE1e5e9} !important;
        border-color: transparent;
        box-shadow: none;
        cursor: not-allowed;
        user-select: none;
        &:hover {
            color: ${MIGRATED_COLORS.literalC4ccd3};
            cursor: not-allowed;
        }
    }
`;

const SearchInputButton = styled.button`
    ${SearchInputButtonCss};
`;

export default SearchInputButton;
